module.exports = __webpack_public_path__ + "static/img/MOOCS_DownBg.6c3c121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/MOOCS_DownBg.png
// module id = RNvz
// module chunks = 0